export const FOURSQUARE_PLACES_API =
  process.env.REACT_APP_API || 'https://api.foursquare.com/v2/venues';

export const FOURSQUARE_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;

export const FOURSQUARE_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET;

export const FOURSQUARE_API_VERSION =
  process.env.FOURSQUARE_API_VERSION || '20200530';

export const REVERSE_API =
  process.env.REACT_APP_API || 'https://nominatim.openstreetmap.org';
